<template>
  <router-link :to="compTo" :tag="tag" :class="{on: compIsCurrentPath}">
    <slot/>
  </router-link>
</template>
<script>
export default {
  name: "SLink",
  props: {
    to: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      required: false,
      default: "a"
    }
  },
  computed: {
    compTo() {
      if (this.to == this.$route.path) { // 현재페이지를 다시 클릭하는 것이라면 ?
        const newTo = this.to + (this.to.indexOf('?') >= 0 ? "&" : "?") + "__hash=" + T.randomAZ(10).toLowerCase()
        return newTo
      }
      return this.to
    },
    compIsCurrentPath() {
      return this.to == this.$route.path
    },
  },
}
</script>